module.exports = __webpack_public_path__ + "static/img/patho-pus-medium-CIPvIo9U.a67d5653.png";